import React from 'react';
import Icon from "../Icon";
import {SpinLoaderPercentage} from "../Loader";


const UploadMultipleGallery = ({
           isError = false,
           error = false,
           uploadProgress = {},
           preview = false,
           cancelFile = () =>{}
    }) =>{

    return (
            <div className={`uploading-media ${isError ? "error" : ""}`}>
                <div className={`media-block`}>
                    <div className={"white-borders"}
                         style={{background: `url(${preview}) 0% 0% / cover`}} />
                    {!isError && (<div className={"progress"}><SpinLoaderPercentage percentage={uploadProgress.percentCompleted} /></div>)}
                    <span className={"close-button"} onClick={()=>cancelFile()}><Icon type={"close"}/></span>
                </div>
                {isError ? (<span className="file-data">{error}</span>) : null }
            </div>
    )
};

export default UploadMultipleGallery;